import React, { useState } from "react";
import { Form, Radio, Select, Input } from "antd";

const DischargeFunctionalStatus = ({ form }) => {
  // const [assistanceType, setAssistanceType] = useState(null);
  const ambulation = Form.useWatch(
    ["functional_discharge", "ambulation"],
    form
  );
  const assistanceType = Form.useWatch(
    ["functional_discharge", "assistance_type"],
    form
  );
  const bedType = Form.useWatch(["functional_discharge", "bed_type"], form);
  const showOther = assistanceType === "Other" || bedType === "Other";

  return (
    <div>
      <Form.Item
        label="Ambulation"
        name={["functional_discharge", "ambulation"]}
      >
        <Radio.Group
          onChange={() => {
            form.setFieldValue(
              ["functional_discharge", "assistance_type"],
              null
            );
            form.setFieldValue(["functional_discharge", "bed_type"], null);
            form.setFieldValue(
              ["functional_discharge", "other_assistance"],
              null
            );
          }}
          value={ambulation}
          options={[
            { value: "Independent", label: "Independent" },
            { value: "Assisted", label: "Assisted" },
            { value: "Bed Bound", label: "Bed Bound" },
          ]}
        />
      </Form.Item>

      {/* Show Select only when "Assisted" is selected */}
      {ambulation === "Assisted" && (
        <Form.Item
          label="Assistance Type"
          name={["functional_discharge", "assistance_type"]}
        >
          <Select>
            <Select.Option value="Wheelchair">Wheelchair</Select.Option>
            <Select.Option value="Cane">Cane</Select.Option>
            <Select.Option value="Walker">Walker</Select.Option>
            <Select.Option value="Braces">Braces</Select.Option>
            <Select.Option value="Prosthesis">Prosthesis</Select.Option>
            <Select.Option value="Helper">Helper</Select.Option>
            <Select.Option value="Other">Other</Select.Option>
          </Select>
        </Form.Item>
      )}

      {ambulation === "Bed Bound" && (
        <Form.Item
          label="Assistance Type"
          name={["functional_discharge", "bed_type"]}
        >
          <Select>
            <Select.Option value="Independent Bed Mobility">
              Independent Bed Mobility
            </Select.Option>
            <Select.Option value="Assisted Bed Mobility">
              Assisted Bed Mobility
            </Select.Option>
            <Select.Option value="Dependent Bed Mobility">
              Dependent Bed Mobility
            </Select.Option>
            <Select.Option value="Other">Other</Select.Option>
          </Select>
        </Form.Item>
      )}

      {/* Show input field when "Other" is selected */}
      {showOther && (
        <Form.Item
          label="Specify Other Assistance"
          name={["functional_discharge", "other_assistance"]}
        >
          <Input placeholder="Please specify" />
        </Form.Item>
      )}

      <Form.Item
        label="Bowel Incontinence"
        name={["functional_discharge", "bowel_incontinence"]}
      >
        <Radio.Group
          options={[
            { value: "No", label: "No" },
            { value: "Yes", label: "Yes" },
            { value: "Occasionally", label: "Occasionally" },
            { value: "Colostomy", label: "Colostomy" },
          ]}
        />
      </Form.Item>

      <Form.Item
        label="Bladder Incontinence"
        name={["functional_discharge", "bladder_incontinence"]}
      >
        <Radio.Group
          options={[
            { value: "No", label: "No" },
            { value: "Yes", label: "Yes" },
            { value: "Occasionally", label: "Occasionally" },
            { value: "Catheterised", label: "Catheterised" },
          ]}
        />
      </Form.Item>
    </div>
  );
};

export default DischargeFunctionalStatus;
